import type { CSSProperties } from 'react';

/**
 * Anything rendered beside the conversation reads at the size of the conversation — a card body a
 * step below the message introducing it makes a result look like a footnote to it. One ratio off
 * Tailwind's own scale, so each surface keeps its hierarchy and only starts where the text does.
 *
 * Custom properties rather than edited `text-*` classes: Tailwind's size utilities read these, so
 * one object moves a whole subtree and leaves the same components alone elsewhere. Line heights are
 * ratios of their own size, so they follow.
 */
export const MESSAGE_TEXT_SCALE = {
  '--text-xs': '0.857rem',
  '--text-sm': '1rem',
  '--text-base': '1.143rem',
  '--text-lg': '1.286rem',
  '--text-xl': '1.429rem',
} as CSSProperties;
